export const DEFAULT_ERROR_MSG = 'Something went wrong';
export const DOC_NOT_FOUND =
  'We are sorry, but the document you are looking for does not exist.';
